export default __webpack_public_path__ + "static/media/KOD0064-min.92d499fa.webp";